import { useActivitiesContext } from '@user/features/Activity/context'

export function useData() {
  const [{ filters }] = useActivitiesContext()

  return { filters }
}
